<div id="date-fiters">
  <div class="row">
    <p class="title">Datas</p>
    <a class="clean-filters">Limpar</a>
  </div>

  <div class="row">
    <div class="one-quarter">
      <label>Período de cadastro</label>
      <nz-date-picker nzClassName="datepicker" nzDropdownClassName="datepicker-popup" nzPlaceHolder="dd/mm/yyyy"
        nzFormat="dd/MM/yyyy">
      </nz-date-picker>
    </div>
    <div class="one-quarter">
      <label>Sem atual</label>
      <nz-date-picker nzClassName="datepicker" nzDropdownClassName="datepicker-popup" nzPlaceHolder="dd/mm/yyyy"
        nzFormat="dd/MM/yyyy">
      </nz-date-picker>
    </div>
    <div class="one-quarter">
      <label>Período de atualização</label>
      <nz-date-picker nzClassName="datepicker" nzDropdownClassName="datepicker-popup" nzPlaceHolder="dd/mm/yyyy"
        nzFormat="dd/MM/yyyy">
      </nz-date-picker>
    </div>
    <div class="one-quarter">
      <label>Construção</label>
      <nz-date-picker nzClassName="datepicker" nzDropdownClassName="datepicker-popup" nzPlaceHolder="dd/mm/yyyy"
        nzFormat="dd/MM/yyyy">
      </nz-date-picker>
    </div>
  </div>
</div>